import * as React from 'react';
import { useLayoutEffect } from 'react';
import { useController } from 'react-scroll-parallax';
import { Helmet } from 'react-helmet';
import 'focus-visible';

import '@fontsource/work-sans/400.css';
import '@fontsource/work-sans/500.css';
import '@fontsource/work-sans/600.css';
import '@fontsource/work-sans/700.css';

import './style.scss';

import Header from '../Header';
import Footer from '../Footer';

const ParallaxCache = () => {
  const { parallaxController } = useController();

  useLayoutEffect(() => {
    const handler = () => parallaxController.update();

    if (document.readyState === "complete") {
      window.requestAnimationFrame(() => {
        handler();
      });
    } else {
      window.addEventListener('load', handler);
      return () => document.removeEventListener('load', handler);
    }
  }, [parallaxController]);

  return null;
};

const Layout = ({ pageTitle, children }) => {
  return (
    <main className="layout">
      <Helmet
        htmlAttributes={{
          lang: 'en',
        }}
      >
        <meta charSet="utf-8" />
        <meta
          name="description"
          content="The Professional Standards Councils and its agency, the Professional Standards Authority, work to improve professional standards and protect consumers of professional services across Australia."
        />
        <title>{pageTitle} | Professional Standards Councils</title>
      </Helmet>

      <Header />

      {typeof window !== `undefined` &&
        <ParallaxCache />
      }
      <main>{children}</main>

      <Footer />
    </main>
  );
};

export default Layout;
